import { jsx as i, jsxs as e } from "react/jsx-runtime";
import { memo as p } from "react";
import { Typography as s, colors as r, Chip as h } from "@goshippo/components";
import { NavigationCategory as v, NavigationCategoryTitle as c, NavigationCategoryIcon as b, NavigationCategoryItems as u, NavigationMenuItem as C, NavigationMenuTypography as N } from "./Navigation.styled.js";
const f = () => i(h, { sx: {
  "> span": {
    fontWeight: "bold"
  },
  backgroundColor: `${r.backgroundDeemphasized} !important`
}, color: "info", iconVariant: null, label: "BETA" }), E = p(({ categories: m, currentRoute: d, linkComponent: l }) => i("div", { "data-testid": "settings-menu-list", children: m.map((n) => e(v, { "aria-labelledby": `nav-cat-${n.name}`, component: "nav", children: [e(c, { children: [(n == null ? void 0 : n.icon) && i(b, { "aria-label": `${n.name} icon`, children: n == null ? void 0 : n.icon }), i(s, { variant: "bodyEmphasized", component: "div", color: r.text.secondary, id: `nav-cat-${n.name}`, children: n.name }), n.beta && i(f, {})] }), i(u, { children: n.items.map(({ name: t, route: a }) => {
  const o = d === a;
  return i(C, { isCurrentRoute: o, component: l, "data-testid": a, to: a, "aria-current": o, children: i(N, { variant: o ? "bodyEmphasized" : "body", component: "span", children: t }) }, t);
}) })] }, n.name)) }));
export {
  E as Navigation
};
//# sourceMappingURL=Navigation.js.map
